<template>
    <div class="container-fluid">
        <!-- Page Heading -->
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Call Me Back Requests</h1>
        </div>

        <!-- Content Row -->
        <div class="row">
            <div class="col-md-10 text-center py-5 mx-auto" v-if="total == 0 && searchStatus == status.LOADED">
                <div class="alert alert-danger" role="alert">
                    No results found 
                    <button type="button" class="btn btn-sm btn-light float-right mr-5"  @click="refreshResults()">
                        <font-awesome-icon :icon="['fas', 'redo-alt']" />
                        Refresh
                    </button>
                </div>
            </div>
            <div class="col-md-12 pt-4 d-flex" v-if="total > 0 && searchStatus == status.LOADED">
                <div class="form-inline mb-3">
                <div class="form-group">
                    <label class="pr-2">Results per page: </label>
                    <select v-model="form.size" type="number" class="custom-select" @change="changeSize()">
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="150">150</option>
                        <option value="200">200</option>
                        <option value="250">250</option>
                        <option value="0">All</option>
                    </select>
                </div>
                </div>
                <p class="text-primary font-weight-bold ml-3 mt-1 pt-1">Showing results {{ form.page * form.size + 1 }} - {{ form.page * form.size + tableRows.length }} of {{ total }}</p>
            </div>
            <div class="col-md-12 table-responsive" v-if="tableRows.length > 0 && searchStatus == status.LOADED">
                <table class="table table-bordered table-striped table-hover table-sm">
                    <thead>
                        <tr>
                            <th scope="col">
                                <a href="#" @click.prevent="sortRequests('d')">
                                    Date 
                                    <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='d'" />
                                </a>
                            </th>
                            <th scope="col">
                                <a href="#" @click.prevent="sortRequests('n')">
                                    Name 
                                    <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='n'" />
                                </a>
                            </th>
                            <th scope="col">
                                <a href="#" @click.prevent="sortRequests('p')">
                                    Phone
                                    <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='p'" />
                                </a>
                            </th>
                            <th scope="col">
                                <a href="#" @click.prevent="sortRequests('e')">
                                    Email
                                    <font-awesome-icon :icon="form.order_desc ? 'sort-alpha-down' : 'sort-alpha-up'" v-if="form.order_by=='e'" />
                                </a>
                            </th>
                            <th scope="col">
                                Best time to call 
                            </th>
                            <th scope="col">
                                Help needed 
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in tableRows" :key="row.id">
                            <td>{{ row.date }}</td>
                            <td>{{ row.name }}</td>
                            <td class="d-flex justify-content-between">{{ row.phone_number }} <button class="btn btn-success" @click="callNumber(row.phone_number)"><font-awesome-icon :icon="['fas', 'phone-alt']" /> Call</button></td>
                            <td>{{ row.email_address }}</td>
                            <td>{{ row.best_time_to_call }}</td>
                            <td>{{ row.help_needed }}</td>
                        </tr>
                    </tbody>
                </table>
                <nav>
                  <ul class="pagination justify-content-end">
                    <li class="page-item" v-if="form.page > 0"><a class="page-link" href="#" @click.prevent="searchRequests(form.page-1)">Previous</a></li>
                    <li class="page-item" v-if="has_more"><a class="page-link" href="#" @click.prevent="searchRequests(form.page+1)">Next</a></li>
                  </ul>
                </nav>
            </div>
            <div class="col-md-12 text-center" v-if="searchStatus == status.LOADING">
              <div class="spinner-border" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
            </div>
        </div>
    </div>
</template> 

<script>
import { mapGetters } from "vuex";
import EventBus from "@/utils/event-bus";

export default {
    name: "Callme",
    created() {
        this.form = this.initialForm();
        this.searchRequests(this.form.page);
    },
    data: () => ({
        status: {
            LOADED: 'LOADED',
            LOADING: 'LOADING'
        },
        searchStatus: 'INIT',
        form: {},
        total: 0,
        tableRows: [],
        has_more: false,
    }),
    computed: {
        ...mapGetters([
            'error',
            'system'
        ]),
    },
    methods: {
        initialForm() {
            return {
                page: 0,
                size: 50,
                order_by: 'd',
                order_desc: true,
            }
        },
        changeSize() {
            this.searchRequests(0);
        },
        formatDate(d) {
            let date = d.split(',')

            let [day, month, year] = date[0].split(' ')

            date[0] = [day, month, year].join('-')
            
            return date.join(',')
        },
        sortRequests(field) {
            if (field == this.form.order_by) {
                this.form.order_desc = !this.form.order_desc;
            } else {
                this.form.order_by = field;
                this.form.order_desc = true;
            }
            this.searchRequests(0);
        },
        refreshResults() {
            this.searchRequests(this.form.page);
        },
        async searchRequests(page) {
            this.searchStatus = 'LOADING'
            let requests = [];
            this.has_more = false

            let prevPage = this.form.page
            this.form.page = page

            let result = await this.$store.dispatch('searchCallmeRequests', this.form)

            if (!this.error) {
                this.total = result.data.total;
                this.has_more = result.data.has_more

                const dateFormatOptions = {
                    'day': '2-digit',
                    'month': 'short',
                    'year': '2-digit',
                    'hour': '2-digit',
                    'minute': '2-digit',
                    'second': '2-digit',
                }

                let dateFormat = new Intl.DateTimeFormat('en-gb', dateFormatOptions)

                result.data.results.forEach(req => {

                    let d = Date.parse(req.created_at);
                    let date = this.formatDate(dateFormat.format(d));

                    requests.push({
                        id: req.id,
                        date: date,
                        name: req.name,
                        phone_number: req.phone_number,
                        email_address: req.email_address,
                        best_time_to_call: req.best_time_to_call,
                        help_needed: req.help_needed
                    })
                });
            }
            else {
                this.form.page = prevPage;
                alert(this.error)
            }
            this.tableRows = requests;
            this.searchStatus = 'LOADED';
        },
        callNumber(to) {
            EventBus.$emit('callNumber', to);
        }
    },
}
</script>

<style scoped>
::v-deep .svg-inline--fa {
  margin-right: 0px !important;
}

::v-deep div.material-table {
  padding: 16px !important;
}

::v-deep table th, table td {
    padding: 12px!important;
}

::v-deep table td {
    padding: 12px!important;
}

::v-deep .table-hover tbody tr:hover {
  background-color: #fceec9 !important;
  color: #858796;
}

::v-deep .table-hover tbody tr:active {
  background-color: #b8daff !important;
  color: #858796;
}

::v-deep tbody tr td div {
  font-size: 16px !important;
}

::v-deep thead tr th {
  font-size: 16px !important;
}

::v-deep .table-header {
  display: none;
}

::v-deep .table-header .actions {
  display: none;
}

::v-deep .material-pagination {
  list-style: none !important;
  padding-top: 8px !important;
  padding-left: 20px !important;
}

::v-deep .datatable-length label {
  margin-bottom: 0px !important;
}

::v-deep  .btn.focus, .btn:focus {
    box-shadow: none!important;
}

::v-deep table {
  width: 100%;
}

::v-deep table th:last-child {
  width: 320px!important;
}
</style>